import type React from 'react';

import { BreadcrumbLink, Breadcrumbs } from '@change-corgi/design-system-legacy/components/navigation';

import { useTagBreadcrumbs } from './hooks/useTagBreadcrumbs';

export const TagBreadcrumbs: React.FC = () => {
	const {
		data: { ask, displayed, slug, tag },
	} = useTagBreadcrumbs();

	if (!displayed) return null;

	return (
		<Breadcrumbs>
			<BreadcrumbLink to="/">Change.org</BreadcrumbLink>
			<BreadcrumbLink to={`/topic/${tag?.slug}`}>{tag?.name}</BreadcrumbLink>
			<BreadcrumbLink to={`/p/${slug}`}>{ask}</BreadcrumbLink>
		</Breadcrumbs>
	);
};
